export const getJWTToken = "./authorize/login";
export const getRefreshToken = "./authorize/refreshToken";
export const logOut = "./authorize/logout";
export const getPermissions = "./user/revealpermission";
